import React from 'react';
import { session } from '../../../services/session';
import { NoResult } from '../../misc/loader-utils';
import { camelCaseToDash } from '../common/utils';

import { Table, Column } from '../../ui/table';
import Card from './card';
import BasicDropdown from '../dropdowns/basic-dropdown';

const Overview = ({
  data,
  title,
  description,
  cards,
  columns,
  totalLabel,
  totalValue,
  sortField,
  sortDirection,
  setSortField,
  setSortDirection,
  month,
  setMonth,
  monthOptions,
  params,
  endpoint,
  rowPath,
  setPayoutBreakdownDate,
  rowIdField,
  controlsLabel,
}) => {
  const cardItems = cards ? (
    <div className="cards">
      {cards.map((card, index) => (
        <Card key={index} title={card.title} label={card.label} value={card.value} />
      ))}
    </div>
  ) : null;

  const columnItems = columns.map((column, index) => (
    <Column
      key={index}
      dataKey={column.dataKey}
      label={column.label}
      width={column.width}
      flexWidth={true}
      sortable={column.sortable}
      tooltip={column.tooltip}
      justifyContent={column.justifyContent}
      fontColor={column.fontColor}
      cellRender={column.cellRender}
    />
  ));

  // Give total row invisible columns to keep it aligned with table
  const totalRowColumns = columns.map((column, index) => {
    const style = {
      flexGrow: `${column.width}`,
      flexBasis: `${column.width}px`,
    };
    return index === columns.length - 1 ? (
      <div key={index} className="total-value" style={style}>
        <div>{totalValue}</div>
      </div>
    ) : index === columns.length - 2 ? (
      <div key={index} className="total-label" style={style}>
        <div>Total {totalLabel}: </div>
      </div>
    ) : (
      <div key={index} style={style} />
    );
  });

  const result =
    data.length > 0 ? (
      <div className="payments-overview">
        {cardItems}
        <div className="payments-overview-table">
          <Table
            data={data}
            stickyColumnsCount={1}
            selectedRows={{}}
            onSort={({ field, order }) => {
              setSortField(field);
              setSortDirection(order);
            }}
            sortField={sortField}
            sortOrder={sortDirection}
            rowIdField={rowIdField}
            rowPath={rowPath}
            onRowClick={
              setPayoutBreakdownDate
                ? rowIndex => setPayoutBreakdownDate(data[rowIndex].payout_date)
                : () => {}
            }
          >
            {columnItems}
          </Table>
        </div>
        <div className="total-row">{totalRowColumns}</div>
      </div>
    ) : (
      <>
        <div className="no-result-txt">
          <div className="no-result-title">{`No ${title} to Display`}</div>
          <NoResult type={title.toLowerCase()} noResult={!data.length} />
        </div>
      </>
    );

  const monthDropdownControls = monthOptions ? (
    <>
      <span className="month-dropdown-controls-label">View {title} By:</span>
      <BasicDropdown
        items={monthOptions}
        selectItem={idx => setMonth(monthOptions[idx])}
        dropdownLabel={month.label}
      />
    </>
  ) : null;

  const controlsLabelItem = controlsLabel ? <div className="label">{controlsLabel}</div> : null;

  const sectionTitle = title ? <div className="section-title">{title}</div> : null;
  return (
    <>
      {sectionTitle}
      <div className="section-description">{description}</div>
      <div className="controls">
        {controlsLabelItem}
        <div className="month-dropdown-controls">{monthDropdownControls}</div>
      </div>
      {result}
    </>
  );
};

export default Overview;
